import { NavigationGuard } from "vue-router";

/**
 * メンテナンスチェック処理
 * @param to
 * @param _from
 * @param next
 */
export const checkMaintenance: NavigationGuard = (to, _from, next) => {
  // if (to.meta?.isMaintenancePage) {
  //   next();
  //   return;
  // }

  // // メンテナンス中かチェック
  // const isInMaintenance = maintenanceStore.isInMaintenance;
  // if (isInMaintenance) {
  //   await authStore.logout();
  //   next({
  //     name: "Maintenance"
  //   });
  //   return;
  // }
  next();
};
